import { Pipe, PipeTransform } from '@angular/core';
import type {
	ProductFlowButton,
	ProductFlowComponent,
} from '@app/product/components/product-flow/product-flow.component';
import { isFormProduct } from '@app/product/utils/product-utils';
import { I18nService } from '@app/shared/utils/i18n.service';

const ALLOWED_FORM_TYPES = new Set(['quote', 'order']);

/** Pipe to get the label of a product flow button. */
@Pipe({ name: 'getProductFlowButtonLabel' })
export class GetProductFlowButtonLabelPipe implements PipeTransform {
	constructor(private readonly i18n: I18nService) {}
	/** Pipe to get the label of a product flow button. */
	transform(button: ProductFlowButton, product: api.ProductDto, context: ProductFlowComponent): string {
		// Form products are a special case
		const formType = product?.metadata?.form_type;
		if (!isFormProduct(product) || !ALLOWED_FORM_TYPES.has(formType!)) {
			return typeof button.label === 'function' ? button.label.call(context) : button.label;
		}
		// Button text is localized
		const buttonText = this.i18n.getText(product?.metadata?.form_button_text);
		if (buttonText) return buttonText;
		return formType === 'quote'
			? $localize`:@@ProductFlowStepButtonLabelFormRequestQuote:Request quote`
			: $localize`:@@ProductFlowStepButtonLabelFormOrder:Order`;
	}
}
